/*

import float_mix from '@/mixins/float_mix'
mixins:[float_mix],
@mouseenter="fl_positionTooltip"
@mouseenter="(e)=>fl_positionTooltip(e, {placement:'top'})"

 */

// https://floating-ui.com
import { computePosition, offset, shift, flip, detectOverflow } from '@floating-ui/dom'

const float_mix = {
  data() {
    return {}
  },
  methods: {
    fl_positionTooltip(e, options) {
      const referenceEl = e.currentTarget // event.currentTarget is only available while the event is being handled
      const children = [].slice.call(referenceEl.children) // create array from HTMLCollection
      const element = children.find(el => el.className.includes('csst_content'))
      // if (!element) return
      this.fl_setPositionStyle({ referenceEl, element, options })
    },
    fl_positionMenu(e, options, boundary) {
      const referenceEl = e.currentTarget
      const children = [].slice.call(referenceEl.children)
      const element = children.find(el => el.className.includes(options.elClass || 'cssm_content'))
      // if (!element) return
      // console.log(e, element, boundary)
      this.fl_setPositionStyle({ referenceEl, element, boundary, options })
    },
    fl_getVirtualEl({ e, options = {} }) {
      if (e?.touches) {
        e = {
          clientX: e?.touches[0]?.clientX,
          clientY: e?.touches[0]?.clientY,
        }
      }
      let { clientX, clientY } = e
      clientX += options.offset || options.offsetX || 0
      clientY += options.offset || options.offsetY || 0
      const virtualEl = {
        getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            x: clientX,
            y: clientY,
            left: clientX,
            right: clientX,
            top: clientY,
            bottom: clientY,
          }
        },
      }
      return virtualEl
    },
    fl_followMouse(e, boundary, customEl, options, modifiers) {
      boundary = boundary ?? e.currentTarget
      if (!boundary) return
      let element = customEl
      if (!element) {
        const children = [].slice.call(boundary.children) // create array from HTMLCollection
        element = children.find(ch => ch.className.includes('csst_follow-content'))
      }

      const virtualEl = this.fl_getVirtualEl({ e, options })
      this.fl_setPositionStyle({
        referenceEl: virtualEl,
        element,
        options,
        boundary,
        modifiers,
        // modifiers: {
        //   has_flip: false,
        //   has_shift: false,
        // },
      })
    },
    fl_setPositionStyle({
      referenceEl,
      element,
      options,
      modifiers = {
        has_flip: true,
        has_shift: true,
      },
      boundary,
    }) {
      if (!referenceEl || !element) return

      options = options || {}
      const offsetValue = options.offset ?? 2
      const paddingValue = options.padding ?? 4

      const middleware = [
        offset(offsetValue),
        ...(modifiers.has_shift ? [shift({ padding: paddingValue })] : []),
        ...(modifiers.has_flip ? [flip()] : []),
        // autoPlacement(),
        ...(boundary
          ? [
              {
                name: 'detectOverflow',
                async fn(mdArgs) {
                  const overflow = await detectOverflow(mdArgs, { boundary })
                  const { top, bottom, left, right } = overflow
                  const { ignoreBoundary } = options
                  // let ignoreBoundary = options.ignoreBoundary || boundary.offsetWidth<
                  const x = ignoreBoundary
                    ? mdArgs.x
                    : right > 0
                      ? mdArgs.x - right
                      : left > 0
                        ? mdArgs.x + left
                        : mdArgs.x < 0 || mdArgs.x === 0
                          ? 0
                          : mdArgs.x
                  const y = ignoreBoundary
                    ? mdArgs.y
                    : bottom > 0
                      ? mdArgs.y - bottom
                      : top > 0
                        ? mdArgs.y + top
                        : mdArgs.y < 0 || mdArgs.y === 0
                          ? 0
                          : mdArgs.y

                  // console.log({
                  //   overflow,
                  //   mdArgs,
                  //   x,
                  //   y,
                  //   top,
                  //   bottom,
                  //   left,
                  //   right,
                  //   boundary,
                  // })
                  return { x, y }
                },
              },
            ]
          : []),
      ]

      try {
        computePosition(referenceEl, element, {
          placement: options.placement || 'bottom-start',
          strategy: options.strategy || 'fixed',
          middleware,
          ...options,
        }).then(
          ({
            x,
            y,
            // placement,
            // strategy,
            // middlewareData,
            // ...rest
          }) => {
            // console.log({
            //   x,
            //   y,
            //   placement,
            //   strategy,
            //   middlewareData,
            //   ...rest,
            // })
            // console.log(rest)
            element.style.position = options.strategy || 'fixed'
            element.style.left = `${x}px`
            element.style.top = `${y}px`
          },
        )
      } catch (error) {
        console.log(referenceEl)
        console.log(element)
        console.error('EROR - fl_setPositionStyle')
      }
    },
  },
}

export default float_mix
